import posthog from "posthog-js";
import { usePublishPlan } from "mutations/CustomPlans/usePublishPlan";
import { useBuildingModelUid } from "hooks/useBuildingModelUid";
import { useUnpublishPlan } from "mutations/CustomPlans/useUnpublishPlan";
import { Paragraph } from "components/atoms/Typography";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { CheckMarkIcon, CloseIcon } from "components/atoms/Icon";

import styles from "./EditCustomPlanButton.module.scss";

interface PublishPlanButtonProps {
    buildingModelCarbonReductionPlan: BuildingModelCarbonReductionPlan;
}

function PublishPlanButton({ buildingModelCarbonReductionPlan }: PublishPlanButtonProps) {
    const { mutate: publishPlanMutation, isLoading: publishPlanLoading } = usePublishPlan();
    const { mutate: unpublishPlanMutation, isLoading: unpublishPlanLoading } = useUnpublishPlan();
    const buildingModelUid = useBuildingModelUid();
    const loading = publishPlanLoading || unpublishPlanLoading;
    const myPlansEnabled = useFeatureFlagEnabled("my-plans");
    const handlePublishPlan = () => {
        publishPlanMutation({
            planId: buildingModelCarbonReductionPlan.id,
            buildingModelUid,
        });
        posthog.capture("Custom plan published.");
    };
    const handleUnpublishPlan = () => {
        unpublishPlanMutation({
            planId: buildingModelCarbonReductionPlan.id,
            buildingModelUid,
        });
        posthog.capture("Custom plan unpublished.");
    };

    const handleButtonClick = () => {
        if (buildingModelCarbonReductionPlan.isPublished) {
            handleUnpublishPlan();
        } else {
            handlePublishPlan();
        }
    };

    if (!myPlansEnabled) {
        return null;
    }

    if (publishPlanLoading) {
        return (
            <button type="button" disabled={true} onClick={handleButtonClick} className={styles.addProjectButton}>
                <Paragraph style={{ color: "var(--audette-gray-400)" }}>Publishing plan...</Paragraph>
            </button>
        );
    }

    if (unpublishPlanLoading) {
        return (
            <button type="button" disabled={true} onClick={handleButtonClick} className={styles.addProjectButton}>
                <Paragraph style={{ color: "var(--audette-gray-400)" }}>Unpublishing plan...</Paragraph>
            </button>
        );
    }
    return (
        <button type="button" disabled={loading} onClick={handleButtonClick} className={styles.addProjectButton}>
            {buildingModelCarbonReductionPlan.isPublished ? <CloseIcon /> : <CheckMarkIcon />}

            <Paragraph>{buildingModelCarbonReductionPlan.isPublished ? "Unpublish" : "Publish"} plan</Paragraph>
        </button>
    );
}

export default PublishPlanButton;
